import { useEffect, useRef } from 'react';

import {
  Box,
  BoxProps,
  Flex,
  FlexProps,
  Input,
  InputProps,
  HStack,
  StackProps,
  useToken,
} from '@vimeo/bokeh';

import { VIEWER_QNA_ANSWER_PLACEHOLDER_ANIMATION } from '../../constants';

export const ResponsiveWrapper = ({
  aiThinking,
  isPlayer = false,
  ...props
}: BoxProps & { aiThinking: boolean; isPlayer?: boolean }) => (
  <Box
    w="100%"
    h="100%"
    flex="1 0 auto"
    maxH="100%"
    minH="0"
    borderRadius={'1rem'}
    css={
      aiThinking
        ? ''
        : isPlayer
        ? `
      background-color: transparent;
    `
        : ``
    }
    {...props}
  />
);

export const QuestionInput = ({
  isPlayer = false,
  isLoading,
  ...props
}: InputProps & { isPlayer?: boolean; isLoading: boolean }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (isPlayer) {
      window.addEventListener('message', (event) => {
        if (event.data.event === 'componentVisibilityChange' && event.data.data) {
          inputRef.current?.focus();
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Input
      alignSelf="flex-end"
      ref={inputRef}
      css={`
        &:disabled {
          pointer-events: none;
          opacity: 60%;
        }
      `}
      sx={{
        paddingRight: '40px',
        ...(isLoading ? { overflow: 'hidden', textOverflow: 'ellipsis' } : {}),
      }}
      {...props}
    />
  );
};

export const AnswerTextPlaceholder = ({ ...props }: BoxProps) => {
  const stroke = useToken('semanticTokens', 'colors.stroke');
  const textSecondary = useToken('semanticTokens', 'colors.text-secondary');
  return (
    <Box
      opacity="50%"
      borderRadius="8px"
      background={`radial-gradient(circle at center, ${textSecondary}, ${stroke} 90%)`}
      backgroundSize="200% 200%"
      css={VIEWER_QNA_ANSWER_PLACEHOLDER_ANIMATION}
      {...props}
    />
  );
};

export const ViewerQnAHeaderWrapper = ({ ...props }: StackProps) => (
  <HStack borderBottom="0.5pt solid" borderBottomColor="stroke" maxH="80px" {...props} />
);

export const LoaderWrapper = ({ ...props }: FlexProps) => (
  <Flex w="100%" h="100%" alignItems="center" justifyContent="center" {...props} />
);
